import React, { useState } from 'react';
import * as S from './style';  // Reuse your slider styling, or adapt as needed
import { AudioPlayer } from '..';
import { publicUrlStr } from '../../utils';

import { SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation } from 'swiper/modules';
import 'swiper/css';           // core Swiper CSS
import 'swiper/css/navigation';// navigation module CSS

interface ILocalAudio {
  id: number;
  title: string;
  source: string; // e.g. "apec1.mp4"
}

interface AudioSliderProps {
  title: React.ReactNode;
  audios: ILocalAudio[];
}

// A VideoSlider that opens VideoPlayer on click
function AudioSlider({ title, audios }: AudioSliderProps) {
  // State to track which video is selected, if any
  const [selectedAudio, setSelectedAudio] = useState<ILocalAudio | null>(null);

  // When a tile is clicked, set its file as selected
  const handleClick = (audio: ILocalAudio) => {
    setSelectedAudio(audio);
  };

  // Close the player by clearing selected video
  const handleClosePlayer = () => {
    setSelectedAudio(null);
  };

  return (
    <S.SliderWrapper>
      <S.SliderTitle>{title}</S.SliderTitle>
      {/*Conditional: Check if the video list is empty*/}
      {audios.length === 0 ? (
        <S.NoMediaMessage>Sorry! No content available for this category 😭</S.NoMediaMessage>
      ) : (
        <S.MySwiper
          modules={[Navigation, FreeMode]}
          navigation
          freeMode
          slidesPerView="auto" // show as many slides as will fit
          style={{ width: '97%' }}
          /*        
          // optional: you can set slidesPerView, spaceBetween, etc.
          slidesPerView={4} // how many slides to show at once (tweak as needed)
          spaceBetween={1}  // space between slides
          */
        >
          {audios.map((aud) => (
            <SwiperSlide key={aud.id}>
              <S.AudioSliderItem onClick={() => handleClick(aud)}>
                {/*Set thumbnail as background*/}
                <S.AudioTile audioThumbUrl={ `${publicUrlStr()}/audios/thumbnail.jpg` }/>
                <S.MediaTitle>{aud.title}</S.MediaTitle>
              </S.AudioSliderItem>
            </SwiperSlide>
          ))}
        </S.MySwiper>
      )}

      {/* Conditionally render the VideoPlayer if a video is selected */}
      {selectedAudio && (
        <AudioPlayer
          audioSource={selectedAudio.source}
          onClose={handleClosePlayer}
        />
      )}
    </S.SliderWrapper>
  );
}

export default AudioSlider;